import { AUTH_EMAIL_OTP_CODE_LENGTH } from '@/constants/auth/login';
import { AuthPostAuthActionType } from '@/enums/AuthPostAuthActionType';
import type { AuthVerifyAuthenticatedResponse } from '@/features/auth/types';
import type { Dictionary } from '@/features/i18n/dictionaries';
import { buildProductMailRoute } from '@/features/mail/routes';
import type { AuthOtpIssueStep, AuthOtpTransport } from '@/interfaces/AuthOtp';

const AUTH_OTP_AUTO_SUBMIT_REGISTRY_KEY = '__chattengerAuthOtpAutoSubmitKeys';

export const normalizeOtpCode = (value: string, length = 4) => value.replace(/[^\d]/g, '').slice(0, length);

export const normalizeEmailOtpCode = (value: string) => value.replace(/[^\d]/g, '').slice(0, AUTH_EMAIL_OTP_CODE_LENGTH);

export const getAutomaticOtpSubmitRegistry = () => {
    const globalWindow = window as Window & {
        [AUTH_OTP_AUTO_SUBMIT_REGISTRY_KEY]?: Record<string, true>;
    };

    globalWindow[AUTH_OTP_AUTO_SUBMIT_REGISTRY_KEY] ??= {};

    return globalWindow[AUTH_OTP_AUTO_SUBMIT_REGISTRY_KEY];
};

export const getOtpHintLabel = ({ dictionary, deliveryTransport }: { dictionary: Dictionary['auth']; deliveryTransport: AuthOtpTransport | null }) =>
    deliveryTransport === 'sms' ? dictionary.smsOtpHint : dictionary.callOtpHint;

export const getNextOtpActionBaseLabel = ({
    dictionary,
    nextStep,
    nextTransport,
}: {
    dictionary: Dictionary['auth'];
    nextStep: AuthOtpIssueStep | null;
    nextTransport: AuthOtpTransport | null;
}) => {
    if (nextStep === null || nextTransport === null) {
        return null;
    }

    if (nextTransport === 'call') {
        return nextStep === 'retryPrimary' ? dictionary.retryCall : dictionary.switchToCall;
    }

    return nextStep === 'retryPrimary' ? dictionary.retrySms : dictionary.switchToSms;
};

export const resolveAuthenticatedRedirectPath = ({ response, targetPath }: { response: AuthVerifyAuthenticatedResponse; targetPath: string }) => {
    if (response.postAuthAction?.type === AuthPostAuthActionType.OpenProductMail) {
        return buildProductMailRoute({
            mailboxSlug: response.postAuthAction.mailboxSlug,
        });
    }

    return targetPath;
};
